<template>
  <div
    :class="{
      HelpButton: true,
      hidden:
        $store.state.ui.mode === 'no-map' ||
        $store.state.ui.mode === 'no-years' ||
        $store.state.ui.mode === 'year-highlight' ||
        $store.state.ui.mode === 'highlight-flip'
    }"
    @click="$emit('click')"
  >
    ?
  </div>
</template>

<script>
export default {
  name: "HelpButton"
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.HelpButton {
  align-items: center;
  background-color: $light-gold;
  border-radius: 50%;
  color: $copper;
  cursor: pointer;
  display: flex;
  font-size: 2em;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  width: 40px;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  animation: pulse 10s infinite;

  &:hover {
    background-color: $copper;
    color: white;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 232, 87, 0.8);
    }

    5% {
      box-shadow: 0 0 0 10px rgba(255, 232, 87, 0);
    }

    10% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }

  &.hidden {
    display: none;
  }
}
</style>
